var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineTimerStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13V8c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.25c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-4.41-3.59-8-8-8s-8 3.59-8 8 3.59 8 8 8c.41 0 .75.34.75.75s-.34.75-.75.75c-5.24 0-9.5-4.26-9.5-9.5zM9 2.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.19 21.77c-.66-.38-1.04-1.15-1.04-2.11v-2.31c0-.96.38-1.73 1.04-2.11.66-.38 1.51-.32 2.34.15l2 1.16c.83.48 1.31 1.19 1.31 1.95s-.48 1.47-1.31 1.95l-2 1.16c-.46.27-.93.41-1.38.41-.35 0-.67-.08-.96-.25zm.75-5.24c-.18.1-.29.41-.29.81v2.31c0 .4.11.71.29.81.18.1.5.05.84-.15l2-1.16c.35-.2.56-.45.56-.65s-.21-.45-.56-.65l-2-1.16c-.23-.14-.45-.21-.62-.21a.51.51 0 0 0-.22.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTimerStart);
export default __webpack_public_path__ + "static/media/vuesax-outline-timer-start.6a705f72ad37b99960a947591f4579b7.svg";
export { ForwardRef as ReactComponent };